import { render, staticRenderFns } from "./totais.vue?vue&type=template&id=221c9ab0"
import script from "./totais.vue?vue&type=script&lang=js"
export * from "./totais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports